export const WHATSAPP_URL =
  "https://wa.me/5581999214339?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Dealflow%20Lab%20e%20quero%20agendar%20um%20diagn%C3%B3stico.";
export const WHATSAPP_DISPLAY = "(81) 99921-4339";
export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || "contato@dealflowlab.com.br";
export const LINKEDIN_URL =
  process.env.REACT_APP_LINKEDIN_URL ||
  "https://www.linkedin.com/company/dealflow-lab";

export const NAV = [
  { id: "metodo", label: "Método" },
  { id: "sobre", label: "Sobre" },
  { id: "estrutura", label: "Estrutura" },
  { id: "contato", label: "Contato" },
];

export const BRANDS = [
  "Stanford University", "Yale University", "University of Cambridge", "Kroton",
  "Grupo Ser Educacional", "Intel", "Softrack", "Itaú", "Bradesco",
  "Allianz Seguros", "Alelo", "Vega Finance", "Rede Globo", "Claro",
  "ThyssenKrupp", "Yamaha", "VL Construtora", "Incorporadora Hexagonal",
  "Usina de Obras", "VIVA VL", "EcoRodovias", "FM2C", "GOL Linhas Aéreas",
  "ID Logistics", "Transpet", "Mercado Livre", "CVC", "Whiskas", "Nissin",
  "Ades", "Di Branco Buffet & Recepções", "Mega Alimentos", "Pantera Alimentos",
  "Ocaporã All Inclusive", "Tabaobí Smart Hotel", "Pousada Tabapitanga",
  "Pousada Tabajuba", "Hotel Crôa Mares", "Costazul Turismo e Receptivo",
  "Pousada do Marcílio", "Pousada Pedra do Mar", "Pousada Maravilha",
  "Pousada Arquipélago", "Varandinha & Casa", "Hotel Villa D'Oro",
  "Hotel VillaMaris", "Park Hotel", "Recife Praia Hotel", "Audi3 Contabilidade",
  "Buonora & Oliveira Advocacia", "Dr. Ridelson Melo", "Saúde Brasil",
  "Sonora", "Palora Wedding", "Progen", "Grupo Brasanitas", "Affari",
  "Hidrolabor", "FGM Dental Group", "Léo Foguete", "Joyce Alane",
  "Matheus Fernandes", "Carvalheira na Ladeira", "Reveillon Amoré (Maracaípe)",
  "Expocannabis",
];

export const NUMBERS = [
  { value: 15, prefix: "+", suffix: "", label: "anos de mercado" },
  { value: 60, prefix: "+", suffix: "", label: "clientes atendidos" },
  { value: 30, prefix: "+R$ ", suffix: " mi", label: "em mídia paga gerenciada" },
  { custom: "B2B · B2C · B2B2C", label: "operações em todos os modelos de negócio" },
];

export const METHOD = [
  { step: "01", title: "Atrair", desc: "Google Ads, Meta Ads, LinkedIn Ads, SEO e GEO" },
  { step: "02", title: "Capturar", desc: "landing pages, tracking e CRM" },
  { step: "03", title: "Nutrir", desc: "automação e e-mail marketing" },
  { step: "04", title: "Prospectar", desc: "outbound ativo no LinkedIn" },
  { step: "05", title: "Qualificar", desc: "SDR dedicado" },
  { step: "06", title: "Fechar", desc: "closer dedicado" },
];

export const SOBRE_HIGHLIGHT_A = "Growth não é sorte nem volume de anúncio.";
export const SOBRE_HIGHLIGHT_B = " É método, dado e um time que fecha o que o marketing atrai.";

export const SOBRE_PARAGRAPHS = [
  "Jacqueline Canavarro Marquezeti é a mente por trás da DealFlow Lab. Com mais de 15 anos de mercado, construiu uma trajetória rara: passou por marketing, vendas, dados, tecnologia e negociação de contratos, e conhece cada etapa que separa um anúncio de um contrato assinado.",
  "Liderou áreas inteiras de marketing e vendas, comandou squads multidisciplinares de performance, CRM, SEO, social media e design e geriu orçamentos de alta complexidade em operações B2B, B2C e B2B2C. Atendeu de pousadas em Fernando de Noronha a bancos, seguradoras, multinacionais e instituições de ensino de renome mundial. Também conduziu lançamentos de artistas, turnês nacionais e eventos de grande porte, com gestão de crise em tempo real.",
  "Domina a lógica de crescimento de ponta a ponta: mídia paga, SEO e GEO, CRM, automação, analytics, inteligência artificial e inteligência comercial. Tem MBA em Marketing, Branding e Growth pela PUC-RS e formação em desenvolvimento web full stack, o que a faz falar com a mesma fluência com marketing, tecnologia e comercial.",
  "Na DealFlow Lab, reúne toda essa bagagem em um método: um laboratório de growth que opera como parte da empresa do cliente, com time dedicado, testes constantes e decisões guiadas por números como CAC, LTV e custo por contrato.",
];

export const SOBRE_CHIPS = [
  "Google Ads", "Meta Ads", "LinkedIn Ads", "GA4 e GTM", "CRM", "automação",
  "SEO e GEO", "IA aplicada", "outbound", "inteligência comercial",
];

export const SOBRE_FORMATION =
  "MBA Executive em Marketing, Branding e Growth (PUC-RS); Web Full Stack (Labenu); Marketing (Faculdade Boa Viagem); Cambridge Preparation Course (Londres).";

export const ESTRUTURA = [
  { title: "Especialista em CRM", desc: "Organiza a base, automatiza a régua e não deixa lead morrer no funil." },
  { title: "Especialista em Tráfego Pago", desc: "Gerencia a verba como investimento: teste, dado e corte rápido." },
  { title: "Social Media Sênior", desc: "Sustenta autoridade e presença enquanto a máquina de aquisição roda." },
  { title: "SDR", desc: "Prospecciona, qualifica e entrega reunião pronta na agenda." },
  { title: "Closer", desc: "Conduz a negociação e fecha o que o marketing atraiu." },
];

export const VAGAS = [
  { title: "SDR", desc: "Prospecção ativa e qualificação de leads de alto ticket." },
  { title: "Closer", desc: "Fechamento de contratos com leads prontos para decidir." },
  { title: "Especialista em CRM", desc: "Automação, régua de relacionamento e dados em ordem." },
  { title: "Especialista em Tráfego Pago", desc: "Gestão de mídia com método, teste e número." },
  { title: "Social Media", desc: "Conteúdo e presença que sustentam a máquina de growth." },
];

export const FAQ = [
  {
    q: "Como funciona a estrutura dedicada?",
    a: "Você não contrata um serviço isolado. Um time completo — especialista em CRM, especialista em tráfego pago, social media sênior, SDR e closer — opera como parte da sua empresa, com rotina, metas e rituais definidos no diagnóstico.",
  },
  {
    q: "Qual é o prazo do contrato?",
    a: "O escopo e o ciclo de operação são definidos no diagnóstico e apresentados na proposta, com total transparência. Sem letras miúdas e sem amarras desnecessárias.",
  },
  {
    q: "O que está incluso?",
    a: "Tráfego pago, CRM, automação, outbound ativo, SDR e closer dedicados, tracking de ponta a ponta e relatórios de performance. Tudo operado pelo time da DealFlow Lab.",
  },
  {
    q: "Como medimos resultado?",
    a: "Por números: CAC, LTV e custo por contrato. Cada decisão sai de teste e de dado, e você acompanha tudo em relatórios objetivos.",
  },
];

export const LEGAL_LINE =
  "DealFlow Lab · JACQUELINE CANAVARRO MARQUEZETI LTDA · CNPJ 63.735.961/0001-64 · Recife, PE";
